import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import CityServices from "services/CityServices";
import { notifyError, notifySuccess } from "utils/toast";

const useCitySubmit = (id,setImageFields) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cityUrl1, setCityUrl1] = useState("");
  const [cityUrl2, setCityUrl2] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedCountryCode, setSelectedCountrycode] = useState('');
  const [cityUrl3, setCityUrl3] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [cityUrl4, setCityUrl4] = useState("");
  const [cityUrl5, setCityUrl5] = useState("");
  const [cityUrl6, setCityUrl6] = useState("");
  const [variants, setVariants] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm();

  const removeVariant = (indexToRemove) => {
    setVariants([...variants.filter((_, index) => index !== indexToRemove)]);
  };

  const addVariant = (e) => {
    e.preventDefault();
    if (e.target.value !== '') {
      setVariants([...variants, e.target.value]);
      e.target.value = '';
    }
  };
  const handleStateChange = (state_id) => {
    setSelectedState(state_id);
  };

  const handleCountryChange = (country_code, country_id) => {
    setSelectedCountryId(country_id);
    setSelectedCountrycode(country_code);
  };
 
  
  const onSubmit = async (data) => {
 
    
    setLoading(true);
    try {
      setIsSubmitting(true);

      const CityData = {
        country_name: data.country_name,
        id_state: data.id_state,
        name: data.name,
        sight_seeing: variants,
        image: {}
      };

      if (data.image1 && data.image1_name) {
        CityData.image[data.image1_name] = data.image1;
      }
      if (data.image2 && data.image2_name) {
        CityData.image[data.image2_name] = data.image2;
      }
      if (data.image3 && data.image3_name) {
        CityData.image[data.image3_name] = data.image3;
      }
      if (data.image4 && data.image4_name) {
        CityData.image[data.image4_name] = data.image4;
      }
      if (data.image5 && data.image5_name) {
        CityData.image[data.image5_name] = data.image5;
      }
      if (data.image6 && data.image6_name) {
        CityData.image[data.image6_name] = data.image6;
      }

      if (id) {
        const res = await CityServices.updateCity(id, CityData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await CityServices.addCity({ CityData });
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getCityData = async () => {
    try {
      const res = await CityServices.getCityById(id);

      if (res) {
        // Set basic fields using setValue
        setValue("country_name", res.country_name);
        setValue("id_state", res.id_state);
        setValue("id_country", res.id_country);
        setSelectedCountryId(res.id_country);
        setValue("name", res.name);
        setSelectedState(res.id_state);

        // Handle variants (sight_seeing)
        let rawData = res.sight_seeing;
        let variants = rawData
          .replace(/[{}]/g, '')
          .split('","')
          .map(item => item.replace(/^"|"$/g, '').trim());

        setVariants(variants);

        // Handle images by setting both the field value and the URL in the state
        const setImageAndCityUrls = (image) => {
          const keys = Object.keys(image);
          const values = Object.values(image);

          keys.forEach((key, index) => {
            // Bind the image names to form fields dynamically
            setValue(`image${index + 1}_name`, key);
            setValue(`image${index + 1}`, values[index]);

            // Also update the image URLs in the state for display
            if (index === 0) setCityUrl1(values[index]);
            if (index === 1) setCityUrl2(values[index]);
            if (index === 2) setCityUrl3(values[index]);
            if (index === 3) setCityUrl4(values[index]);
            if (index === 4) setCityUrl5(values[index]);
            if (index === 5) setCityUrl6(values[index]);
          });
        };

        setImageAndCityUrls(res.image);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      // Clear form values and states when the drawer is closed
      setValue("country_name", "");
      setValue("id_country", "");
      setValue("id_state", "");
      setValue("name", "");
      setValue("sight_seeing", []);
      setValue("image1", "");
      setValue("image2", "");
      setValue("country","");
      setValue("image3", "");
      setValue("image4", "");
      setValue("image5", "");
      setValue("image6", "");
      setImageFields([]);
      setCityUrl1("");
      setCityUrl2("");
      setSelectedState("");
      setCityUrl3("");
      setCityUrl4("");
      setCityUrl5("");
      setCityUrl6("");

      setVariants([]);
      clearErrors();
      return;
    }

    if (id) {
      getCityData();
    }else{
      setValue("country_name", "");
    setValue("id_country", "");
    setValue("id_state", "");
    setValue("name", "");
    setValue("sight_seeing", []);
    setValue("image1", "");
    setValue("image2", "");
    setValue("country","");
    setValue("image3", "");
    setValue("image4", "");
    setValue("image5", "");
    setValue("image6", "");
    setImageFields([]);
    setCityUrl1("");
    setCityUrl2("");
    setSelectedState("");
    setCityUrl3("");
    setCityUrl4("");
    setCityUrl5("");
    setCityUrl6("");

    setVariants([]);
    clearErrors();
    return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,loading,setLoading,
    cityUrl1, setCityUrl1,
    cityUrl2, setCityUrl2,handleStateChange,selectedState,
    cityUrl3, setCityUrl3,setSelectedCountrycode,selectedCountryCode,
    cityUrl4, setCityUrl4,setSelectedState,handleCountryChange,
    cityUrl5, setCityUrl5,setSelectedCountryId,selectedCountryId,
    cityUrl6, setCityUrl6,
    variants,
    setVariants,
    addVariant,
    removeVariant,
    clearErrors,
    setError,
  };
};

export default useCitySubmit;
